import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import persistedReducer, { AppState } from './reducer';
import applicationReducer, { ApplicationState } from './applicationReducer';

export type Dispatch = ThunkDispatch<StoreState, unknown, AnyAction>;

export interface StoreState {
  persistedReducer: AppState;
  applicationReducer: ApplicationState;
}

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['persistedReducer'],
};

const rootReducer = combineReducers({
  persistedReducer,
  applicationReducer,
});

export default persistReducer(persistConfig, rootReducer);
